import * as tslib_1 from "tslib";
import { Mapper } from '@services/generics/data.mapper';
import buildODataQuery from '@services/generics/odata.query';
import { map } from 'rxjs/operators';
export var ODATA_COUNT_KEY = '@odata.count';
var ODataService = /** @class */ (function (_super) {
    tslib_1.__extends(ODataService, _super);
    function ODataService(_http, mapper) {
        var _this = _super.call(this) || this;
        _this._http = _http;
        _this.mapper = mapper;
        _this._mapData = function (serverData, customMapper) {
            var items = serverData.value;
            var mappedData = {
                data: [],
                total: 0,
            };
            if (items) {
                mappedData.data = items.map(function (entry) {
                    return _this._toDto(entry, customMapper);
                });
                mappedData.total = serverData[ODATA_COUNT_KEY];
            }
            if (serverData.Keys && serverData.Values) {
                return _this._fromDictionary(serverData);
            }
            if (!items && !serverData.hasOwnProperty(ODATA_COUNT_KEY)) {
                return _this._toDto(serverData, customMapper);
            }
            return mappedData;
        };
        _this._fromDictionary = function (data) {
            var result = {};
            if (data.Keys && data.Values) {
                for (var i = 0; i < data.Keys.length; i++) {
                    result[data.Keys[i]] = data.Values[i];
                }
            }
            return result;
        };
        _this.mapper = mapper;
        return _this;
    }
    ODataService.prototype.get = function (queryOptions, endpoint) {
        var _this = this;
        return this._http.get("" + (endpoint || this._endpoint) + this.getQueryString(queryOptions))
            .pipe(map(function (response) { return _this._mapData(response); }));
    };
    ODataService.prototype.getInstance = function (key, expand, params) {
        var _this = this;
        if (expand === void 0) { expand = null; }
        if (params === void 0) { params = {}; }
        var expansionList = expand === null ? '' : '?$expand=' + expand.join(',');
        return this._http
            .get(this._endpoint + "(" + key + ")" + expansionList, {
            params: params,
        })
            .pipe(map(function (response) { return _this._mapData(response); }));
    };
    ODataService.prototype.getInstanceSet = function (key, queryOptions) {
        var _this = this;
        var endpoint = this._endpoint + "(" + key + ")";
        return this._http.get("" + endpoint + this.getQueryString(queryOptions))
            .pipe(map(function (response) { return _this._mapData(response); }));
    };
    ODataService.prototype.add = function (data) {
        var _this = this;
        var serverData = this._toPoco(data);
        var payload = JSON.stringify(serverData);
        return this._http
            .post(this._endpoint, payload)
            .pipe(map(function (response) { return _this._mapData(response); }));
    };
    ODataService.prototype.update = function (key, data) {
        var serverData = this._toPoco(data);
        var content = JSON.stringify(serverData);
        return this._http
            .put(this._endpoint + "(" + this._keyGen(key) + ")", content, {
            headers: this._jsonHeaders,
        });
    };
    ODataService.prototype.patch = function (key, data) {
        var serverData = this._toPoco(data);
        var content = JSON.stringify(serverData);
        return this._http.patch(this._endpoint + "(" + this._keyGen(key) + ")", content, {
            headers: this._jsonHeaders,
        });
    };
    ODataService.prototype.delete = function (key) {
        return this._http.delete(this._endpoint + "(" + this._keyGen(key) + ")");
    };
    ODataService.prototype.getQueryString = function (queryOptions) {
        return !queryOptions ? '' : buildODataQuery(queryOptions);
    };
    ODataService.prototype._keyGen = function (key) {
        if (typeof key === 'string') {
            return "'" + key + "'";
        }
        return key;
    };
    return ODataService;
}(Mapper));
export { ODataService };
